import {useAppStore} from '../appStore'

export const initiativeAnalyticsActions = {
  useChangeAnalyticsFilters: () => useAppStore(s => s.changeAnalyticsFilters),
  useResetInitiativeAnalytics: () =>
    useAppStore(s => s.resetInitiativeAnalytics),
} as const

export const teamViewActions = {
  useApplyTeamFilters: () => useAppStore(s => s.applyTeamFilters),
  useSetTeamDateFilter: () => useAppStore(s => s.setTeamDateFilter),
  useHydrateTeamFilters: () => useAppStore(s => s.hydrateTeamFilters),
  useSetTeamFilterRowId: () => useAppStore(s => s.setTeamFilterRowId),
  useClearTeamFilters: () => useAppStore(s => s.clearTeamFilters),
} as const
